import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';

import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { MSAL_INSTANCE, MsalModule, MsalService } from '@azure/msal-angular';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppInterceptor } from './interceptor/app.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MarkdownModule } from 'ngx-markdown';
import { ReactiveFormsModule } from '@angular/forms';

export function msalInstanceFactory(): IPublicClientApplication {
	const msalInstance: any = new PublicClientApplication({
		auth: {
			clientId: '93b16dd3-b5d5-4923-ad6f-ee79c145e6f3',
			redirectUri: environment.loginUrl,
			authority: 'https://login.microsoftonline.com/yash.com',
			postLogoutRedirectUri: environment.postLogOutUrl,
		},
		cache: {
			cacheLocation: 'localStorage',
			storeAuthStateInCookie: true,
		},
	});
	msalInstance['browserStorage'].clear();
	return msalInstance;
}

@NgModule({
	declarations: [AppComponent, LoginComponent, PageNotFoundComponent],
	imports: [
		BrowserModule.withServerTransition({ appId: 'serverApp' }),
		AppRoutingModule,
		ReactiveFormsModule,
		MsalModule,
		HttpClientModule,
		BrowserAnimationsModule,
		ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
		MarkdownModule.forRoot(),
		ToastrModule.forRoot({
			closeButton: true,
			positionClass: 'toast-top-full-width',
			toastClass: 'ngx-toastr',
			enableHtml: true,
			preventDuplicates: true,
			maxOpened: 1,
			timeOut: 4000,
			extendedTimeOut: 4000,
		}),
	],
	providers: [
		{
			provide: MSAL_INSTANCE,
			useFactory: msalInstanceFactory,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AppInterceptor,
			multi: true,
		},
		MsalService,
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
